import { atom } from 'jotai';

export const positionAtom = atom<number>(1);
